import { z } from 'zod';

import { schema } from './QBooksCounterpartyCreationPopupContent.schema';

export enum FormFieldId {
    displayName = 'displayName',
    companyName = 'companyName',
    title = 'title',
    givenName = 'givenName',
    middleName = 'middleName',
    familyName = 'familyName',
    suffix = 'suffix',
    billingAddress = 'billingAddress',
    email = 'email',
    primaryPhone = 'primaryPhone',
    mobilePhone = 'mobilePhone',
    fax = 'fax',
    website = 'website',
    currencyId = 'currencyId',
    acctNum = 'acctNum',
    shippingAddress = 'shippingAddress',
    sameAsBillingAddress = 'sameAsBillingAddress',
}

export enum AddressFieldId {
    street = 'street',
    city = 'city',
    postalCode = 'postalCode',
    country = 'country',
    state = 'state',
}

export type FormValues = z.infer<typeof schema>;
